import useMutation from "src/hooks/useMutation";
import { UPDATE_PROJECT_SETTINGS_MUTATION } from "src/constants/graphql/index";
import { CLIENTS_AND_PROJECTS_QUERY } from "src/constants/graphql/queries";

export default function useUpdateProjectSettings() {
  return useMutation(UPDATE_PROJECT_SETTINGS_MUTATION, {
    update(
      cache,
      {
        data: {
          updateProjectSettings: { project },
        },
      }
    ) {
      const data = cache.readQuery({ query: CLIENTS_AND_PROJECTS_QUERY });
      cache.writeQuery({
        query: CLIENTS_AND_PROJECTS_QUERY,
        data: {
          clients: data.clients.map(v => ({
            ...v,
            projects: v.projects.map(p => {
              return p.id === project.id ? project : p;
            }),
          })),
        },
      });
    },
  });
}
